module.exports = __webpack_public_path__ + "static/media/1 lion portrait backpiece hyper realism.1280x1674.a055ac81.webp";